import React from "react";

const Option = ({
  className,
  component,
  style,
  onClick,
  onDoubleClick,
  onMouseOver,
  onMouseOut,
  layerRef,
  children
}) => {
  const htmlTagAttributes = component.htmlTagAttributes || {};
  const type = htmlTagAttributes["type"] || "text";
  const placeholder = htmlTagAttributes["placeholder"] || null;

  return (
    <option
      ref={layerRef}
      type={type}
      placeholder={placeholder}
      className={className}
      style={style}
      onClick={onClick}
      onDoubleClick={onDoubleClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </option>
  );
};

export default Option;
